<template>

    <div class="content-container-white">

        <div class="loading" v-if="!invoice && !error">

        </div>

        <div v-if="error" class="error">
            <div class="mb-4">{{ error }}</div>
            <button type="button" class="btn btn-primary" @click="$router.go(-1)">Zurück</button>
        </div>

        <div class="invoice" ref="invoice" v-if="invoice">
            <img width="160" alt="appwork" v-bind:src="logo" class="mb-4">

            <div class="addresses">
                <div class="issuing__company">
                    <p>{{invoice.issuingCompany.name}}</p>
                    <p>{{invoice.issuingCompany.address.street}}</p>
                    <p>{{invoice.issuingCompany.address.zip}} {{invoice.issuingCompany.address.city}}</p>
                    <p class="mt-4">Tel: {{invoice.issuingCompany.tel}}</p>
                    <p>Email: {{invoice.issuingCompany.email}}</p>
                    <p>Ust-Id: {{invoice.issuingCompany.vatId}}</p>
                </div>
                <div class="customer__address">
                    <p v-if="invoice.customerName">{{invoice.customerName}}</p>
                    <p v-if="invoice.customerStreet">{{invoice.customerStreet}}</p>
                    <p v-if="invoice.customerCity || invoice.customerZip">{{invoice.customerZip}} {{invoice.customerCity}}</p>
                    <p v-if="invoice.customerVatId">{{invoice.customerVatId}}</p>
                </div>
            </div>

            <div>
                <h2 class="mt-5">Rechnung</h2>
                <p>Rechnung Nr: {{invoice.number}}</p>
            </div>
        </div>

        <button class="btn btn-success" @click="downloadPdf" v-if="invoice">pdf</button>
    </div>
</template>

<script>
    import jsPDF from 'jspdf';
    //import html2canvas from 'html2canvas';

    import firestore from "firedb/init";
    import LoginState from "components/auth/LoginState";

    export default {
        name: "InvoiceViewer",

        data: function() {
            return {
                invoice: null,
                error: null,
                logo: LoginState.company.logo
            }
        },
        methods: {

            /*
            downloadPdfCanvas() {

                html2canvas(this.$refs.invoice).then(canvas => {

                    const img = canvas.toDataURL("image/png");

                    var doc = new jsPDF();

                    doc.addImage(img, 'JPEG', 20, 20);
                    doc.save('invoice.pdf');

                });
            },
            */
            downloadPdf() {


                //210 x 297 mm
                const width = 210;
                const height = 297;
                const padding = 15;
                const blue = '#274060';

                var doc = new jsPDF();


                doc.setDrawColor(0);
                doc.setFillColor(blue);
                doc.rect(120, 0, 75, 70, 'F');


                doc.addImage(this.logo, 'PNG', padding, 20, 60, 7);

                //rechnung an
                doc.setFontSize(11);
                doc.setTextColor('#444444');
                doc.text(padding, 45, 'RECHNUNG AN');

                doc.setFontSize(12);
                doc.setFontType('bold');
                doc.setTextColor(blue);
                doc.text(padding, 52, this.invoice.customerName);


                doc.setFontType("normal");
                doc.setFontSize(11);
                doc.setTextColor('#666666');
                doc.text(padding, 59, this.invoice.customerStreet);
                doc.text(padding, 65, this.invoice.customerZip + this.invoice.customerCity);

                /*
                doc.text(padding, 45, this.invoice.issuingCompany.name);
                doc.text(padding, 52, this.invoice.issuingCompany.address.street);
                doc.text(padding, 59, this.invoice.issuingCompany.address.zip + ' ' + this.invoice.issuingCompany.address.city);
*/


                doc.addImage('data:image/png;base64,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'
                    ,'PNG', padding, 275, 5, 6);

                doc.setFontSize(10);
                doc.text(padding + 10, 275, this.invoice.issuingCompany.name);
                doc.text(padding + 10, 280, this.invoice.issuingCompany.address.street);
                doc.text(padding + 10, 285, this.invoice.issuingCompany.address.zip + ' ' + this.invoice.issuingCompany.address.city);


                doc.setFontSize(18);
                doc.setTextColor('#ffffff');
                doc.text(130, 43, 'Rechnung');
                doc.setFontSize(12);
                doc.setTextColor('#eeeeee');
                doc.text(130, 50, 'Nr.: ' + this.invoice.number);



                doc.setDrawColor(0);
                doc.setFillColor(blue);
                doc.rect(padding, height - (padding * 2), width - (padding * 2), 0.2, 'F');


                doc.save('invoice.pdf');
            },
        },

        created() {
            const ref = firestore.collection('invoice').doc(this.$route.params.id);

            ref.get().then(doc => {

                this.invoice = doc.data();
                this.invoice.id = doc.id;
            })
                .catch(e => {
                    console.log(e);
                    this.error = "Rechnung konte nicht geladen werden";
                });
        }
    }
</script>

<style scoped lang="scss">

    .addresses {

        p {
            margin-bottom: 0.3rem;
        }
    }

    .customer__address {
        margin-top:3rem;
    }

    .logo {
        width: 180px;
        margin-bottom:30px;
    }
</style>